import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Cody specific calculation functions
const calculateCodyNetProfit = (grossProfit: number, companyOH: number): number => {
  return grossProfit - companyOH;
};

const calculateCodyCommission = (netProfit: number): number => {
  return netProfit / 2;
};

// Calculate the individual job data from the Cody Sales June CSV
const jobData = [// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
  {
    jobInfo: "E-408: Tim Pyle",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 26481.54,
    grossMarginPct: 0.4734,
    grossProfit: 12536.36,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 26481.54 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-432: Ballard Green Condo 1",
    leadSource: "Previous Customer",
    trade: "Siding",
    contractTotal: 3450.00,
    grossMarginPct: 0.4928,
    grossProfit: 1700.16,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3450.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-424: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 990.00,
    grossMarginPct: 0.6970,
    grossProfit: 690.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 990.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-412: The Enclave at Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 1150.00,
    grossMarginPct: 0.5000,
    grossProfit: 575.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1150.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-395: Solution based  Property management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 255.00,
    grossMarginPct: 0.2000,
    grossProfit: 51.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 255.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-420: North Green Condominium Association",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 244.00,
    grossMarginPct: 0.2000,
    grossProfit: 48.80,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 244.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-387: Linda Jablon",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 4835.00,
    grossMarginPct: 0.6860,
    grossProfit: 3316.81,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4835.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-423: Robert Denton",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 500.00,
    grossMarginPct: 0.5000,
    grossProfit: 250.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 500.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-431: Sandra Rivera",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 13243.63,
    grossMarginPct: 0.3702,
    grossProfit: 4902.79,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 13243.63 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-425: Pennrose Management Wilbourne Estates",
    leadSource: "Referral- Cody's network",
    trade: "Gutters",
    contractTotal: 2999.00,
    grossMarginPct: 0.4665,
    grossProfit: 1399.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2999.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-419: Josh Plevy",
    leadSource: "",
    trade: "Windows & Doors",
    contractTotal: 2598.91,
    grossMarginPct: 0.1774,
    grossProfit: 461.05,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2598.91 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-418: Ed Danoff",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 7810.50,
    grossMarginPct: 0.3969,
    grossProfit: 3099.99,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 7810.50 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2909: Sandra Rivera",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 28096.25,
    grossMarginPct: 0.3000,
    grossProfit: 8428.88,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 28096.25 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2919: Glenford Blanc",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 36739.00,
    grossMarginPct: 0.3000,
    grossProfit: 11021.70,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 36739.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-392: Debra Spriggs, Chair, Board of Trustees People's Congregational United Church of Christ",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 188660.00,
    grossMarginPct: 0.5077,
    grossProfit: 95782.68,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 188660.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-397: Shannon Johnson",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 2999.00,
    grossMarginPct: 0.5632,
    grossProfit: 1689.04,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2999.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-407: Skyler Lemmon",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 9662.00,
    grossMarginPct: 0.4253,
    grossProfit: 4109.25,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 9662.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2914: Jordan  Gottlieb",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 95790.00,
    grossMarginPct: 0.3000,
    grossProfit: 28737.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 95790.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-409: Amanda Campbell",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 18207.90,
    grossMarginPct: 0.3984,
    grossProfit: 7254.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 18207.90 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody's special calculation formula
jobData.forEach(job => {
  job.netProfit = calculateCodyNetProfit(job.grossProfit, job.companyOH);
  job.salesCommission = calculateCodyCommission(job.netProfit);
});

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));
const totalNetProfit = sum(jobData.map(job => job.netProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource || "Unknown";
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Export the Cody June 2025 report data
export const codySalesJuneData: ReportData = {
  kpis: {
    adSpend: 0, // Cody reports typically don't include ad spend
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // Cody structure doesn't use manager fees
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  adSpendBySource: [], // No ad spend data for Cody reports
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,
  period: {
    month: 6, // June
    year: 2025
  }
};